import {Component, OnInit} from '@angular/core';
import {WelfareResultService} from '../../service/welfare-result.service';

@Component({
    selector: 'app-income',
    templateUrl: './income.component.html',
    styleUrls: ['./income.component.css']
})
export class IncomeComponent implements OnInit {

    constructor(private welfareProject: WelfareResultService) {
    }

    ngOnInit() {
    }

    get family() {
        return this.welfareProject.persons;
    }

}
